import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleShippingGuide() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6">
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">Гид</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Доставка из Китая: полный гид по стоимости и срокам
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Калькуляция стоимости доставки из Китая, сравнение перевозчиков, сроки и таможенные нюансы. Узнайте, как сэкономить на доставке.
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 7 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <img
              src="https://readdy.ai/api/search-image?query=Calculator%20next%20to%20world%20map%20and%20measuring%20tape%20on%20warm%20wooden%20desk%2C%20logistics%20planning%20concept%2C%20warm%20desk%20lamp%20lighting%20creating%20cozy%20glow%2C%20organized%20workspace%20with%20shipping%20labels%20and%20box%2C%20international%20shipping%20theme%2C%20editorial%20business%20photography%2C%20global%20commerce%20atmosphere&width=1200&height=600&seq=yoybuy-art-shipping-hero&orientation=landscape"
              alt="Доставка из Китая"
              className="w-full rounded-3xl mb-10 object-cover"
            />

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Способы доставки из Китая</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Доставка — один из ключевых факторов при заказе товаров из Китая. Правильный выбор способа доставки может сэкономить вам до 50% стоимости заказа. <strong>YOYBUY Spreadsheet</strong> помогает оценить стоимость доставки ещё до оформления заказа — вся информация указана в таблицах на платформе <Link to="/" className="text-accent-500 hover:underline">YOYBUY.PRO</Link>.
              </p>

              <div className="space-y-4 mt-6">
                {[
                  { title: 'Экспресс-доставка (DHL, FedEx, UPS)', time: '7-14 дней', cost: 'Высокая', desc: 'Самый быстрый способ. Подходит для срочных заказов и дорогих товаров. Отслеживание на каждом этапе, страховка включена.' },
                  { title: 'Авиапочта (China Post Air, ePacket)', time: '14-21 день', cost: 'Средняя', desc: 'Оптимальный баланс скорости и цены. Хороший выбор для большинства заказов. Доступно отслеживание.' },
                  { title: 'Морская доставка', time: '30-45 дней', cost: 'Низкая', desc: 'Самый экономичный способ для крупных и тяжёлых заказов. Долго, но значительно дешевле авиадоставки.' },
                  { title: 'Железнодорожная доставка', time: '18-25 дней', cost: 'Средняя', desc: 'Растущий по популярности способ для доставки в Европу и страны СНГ. Быстрее моря, дешевле авиа.' },
                ].map((item, i) => (
                  <div key={i} className="p-5 bg-background-100 rounded-2xl">
                    <div className="flex items-start justify-between flex-wrap gap-2 mb-2">
                      <h4 className="text-base font-semibold text-foreground-800">{item.title}</h4>
                      <div className="flex items-center gap-3">
                        <span className="text-xs text-foreground-400 bg-background-200 px-2.5 py-1 rounded-full whitespace-nowrap">{item.time}</span>
                        <span className="text-xs text-foreground-400 bg-background-200 px-2.5 py-1 rounded-full whitespace-nowrap">{item.cost}</span>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Как рассчитать стоимость доставки</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Стоимость доставки зависит от нескольких факторов: веса и объёма посылки, способа доставки, страны назначения и дополнительных услуг (страховка, упаковка). В таблицах YOYBUY Spreadsheet для каждого товара указана примерная стоимость доставки, что позволяет заранее спланировать бюджет.
              </p>
              <div className="p-5 bg-accent-50 rounded-2xl">
                <p className="text-sm text-accent-800 leading-relaxed">
                  <strong>Совет:</strong> объединяйте несколько товаров из разных категорий в один заказ, чтобы сэкономить на доставке. YOYBUY Spreadsheet охватывает 14 категорий — используйте это преимущество для оптимизации расходов.
                </p>
              </div>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">Рассчитайте доставку</h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                В таблицах YOYBUY Spreadsheet указана стоимость доставки для каждого товара. Начните прямо сейчас.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link to="/" className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">YOYBUY<span className="text-accent-500">.PRO</span></Link>
          <p className="mt-3 text-xs text-background-50/30">© 2026 YOYBUY.PRO. Все права защищены.</p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org", "@type": "Article",
          "headline": "Доставка из Китая: полный гид по стоимости и срокам",
          "description": "Калькуляция стоимости доставки, сравнение перевозчиков, сроки и таможенные нюансы при заказе из Китая.",
          "datePublished": "2026-07-05", "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/china-shipping-guide`}
        })}
      </script>
    </main>
  );
}